import React from 'react';
import "../less";
import {Checkbox} from "MWComponents";
import { DropDown } from "MWC";
import file_download_icon from "../img/file_download_icon.svg";
import exit_icon from "../img/exit-icon.svg";

const INF_CHANNEL_OPTION_KEYS = [
    'VACANCY_FORM_INF_CHANNEL_OPTION_01',
    'VACANCY_FORM_INF_CHANNEL_OPTION_02',
    'VACANCY_FORM_INF_CHANNEL_OPTION_03',
    'VACANCY_FORM_INF_CHANNEL_OPTION_04',
    'VACANCY_FORM_INF_CHANNEL_OPTION_05',
    'VACANCY_FORM_INF_CHANNEL_OPTION_06',
    'VACANCY_FORM_INF_CHANNEL_OPTION_07',
];

export default function template() {

  const {drag, setDrag} = this.state;
  const { isMobile } = this.props;

  const INF_CHANNEL_OPTIONS = INF_CHANNEL_OPTION_KEYS.map(key => ({id: this.l10n(key), name: this.l10n(key)}));

  function dragStartHandler(e) {
    e.preventDefault();
    setDrag(true);
  }
  function dragLeaveHandler(e) {
    e.preventDefault();
    setDrag(false);
  }
  function onDropHandler(e) {
    e.preventDefault();
    setDrag(false);
    this.handleFile(e);
  }

  const model = this.getModel(),
    { name, surname, phone, email, file, city, inf_channel } = model.fields,
  getErrors = (field, type) => {
    return field.errors.find(err => err === type);
  };

    return (
        <div className="form-wrapper send-form" onClick={this.closeModal}>
            <div className="form-container">
              <img className="close-btn" alt="exit-icon" src={exit_icon}></img>
              <div className="form-body">
                <div className="form-title">{this.props.vacancyName}</div>
                <div className="form-body">
                  <div className="form-body-item name">
                    <div className="form-sub-title" id="form-sub-title">{this.l10n('VACANCY_FORM_NAME_TITLE')}</div>
                    <div className="form-body-item-double">
                      <input
                        name="name"
                        type="text"
                        className={`form-input name ${
                          !name.isValid && !name.firstInput ? 'red-color' : ''
                        }`}
                        onChange={this.handleChange}
                        placeholder={this.l10n('VACANCY_FORM_NAME_PLACEHOLDER')}
                        onBlur={() => this.onBlurHandle('name')}>
                      </input>
                      <input
                        name="surname"
                        type="text"
                        className={`form-input surname ${
                          !surname.isValid && !surname.firstInput ? 'red-color' : ''
                        }`}
                        onChange={this.handleChange}
                        placeholder={this.l10n('VACANCY_FORM_SURNAME_PLACEHOLDER')}
                        onBlur={() => this.onBlurHandle('surname')}>
                      </input>
                    </div>
                    <div
                      onFocus={this.handleChannelFocus}
                      onBlur={this.handleChannelBlur}
                      className="inf-channel-wrapper"
                    >
                      <DropDown
                        placeholder={this.l10n('VACANCY_FORM_INF_CHANNEL_OPTION_PLACEHOLDER')}
                        name='inf_channel'
                        className={`form-input inf-channel${this.state.infChannelTouched && !inf_channel.value && this.state.infChannelActive ? ' red-color' : ''}`}
                        onChange={(e) => this.handleChange({target: {name: 'inf_channel', value: e.target.value}})}
                        value={inf_channel.value}
                        collection={INF_CHANNEL_OPTIONS}
                      />
                    </div>
                  </div>
                  <div className="form-body-item contacts">
                    <div className="form-sub-title">{this.l10n('VACANCY_FORM_CONTACTS_TITLE')}</div>
                    <input name="phone"
                           type="text"
                           className={`form-input number ${
                             !phone.isValid && !phone.firstInput ? 'red-color' : ''
                           }`}
                           value={phone.value}
                           onChange={this.handleChange}
                           placeholder={this.l10n('VACANCY_FORM_CONTACT_PLACEHOLDER')}
                           onBlur={() => this.onBlurHandle('phone')}
                           onFocus={this.setPhone}
                           maxLength={20}
                           autoComplete="off">
                    </input>
                    <input
                      name="email"
                      type="text"
                      className={`form-input email ${
                        !email.isValid && !email.firstInput ? 'red-color' : ''
                      }`}
                      onChange={this.handleChange}
                      placeholder={this.l10n('VACANCY_FORM_EMAIL_PLACEHOLDER')}
                      onBlur={() => this.onBlurHandle('email')}>
                    </input>
                    <input
                      name="city"
                      type="text"
                      className={`form-input city ${
                        !city.isValid && !city.firstInput ? 'red-color' : ''
                      }`}
                      onChange={this.handleChange}
                      placeholder={this.l10n('VACANCY_FORM_CITY_PLACEHOLDER')}
                      onBlur={() => this.onBlurHandle('city')}>
                    </input>
                  </div>
                  <div className="form-body-item contacts" id="form-body-item-contacts">
                    <div className="form-sub-title" >{this.l10n('VACANCY_FORM_FILE_TITLE')}</div>
                    <div className="file-path-name">{this.state.selectedFile}</div>
                    <label className={`form-input file ${!file.isValid && !file.firstInput ? 'red-color' : ''}`}
                           onDragEnter={e => dragStartHandler(e)}
                           onDragLeave={e => dragLeaveHandler(e)}
                           onDragStart={e => e.preventDefault()}
                           onDragOver={e => e.preventDefault()}
                           onDrop={e => onDropHandler.call(this,e)}>
                      <img src={file_download_icon} alt='file'></img>
                      {drag ? this.l10n('VACANCY_FORM_FILE_PLACEHOLDER-DRAG')
                        : isMobile ? this.l10n('VACANCY_FORM_FILE_PLACEHOLDER_MOB')
                          : this.l10n('VACANCY_FORM_FILE_PLACEHOLDER') }
                      <input name="file" type="file" className="file-input" accept=".jpeg, .png, .pdf, .doc, .docx, .rtf" onChange={this.handleChange} placeholder={this.l10n('VACANCY_FORM_FILE_PLACEHOLDER-DRAG')}></input>
                    </label>
                    <div className={`file-requires ${getErrors(file, 'CAREER_MODAL_FILE_TYPE_ERROR') ? 'form-error' : ''}`} dangerouslySetInnerHTML={{__html: this.l10n('CAREER_MODAL_FILE_TYPE')}}></div>
                    <div className={`file-requires ${getErrors(file, 'CAREER_MODAL_FILE_SIZE_ERROR') ? 'form-error' : ''}`} dangerouslySetInnerHTML={{__html: this.l10n('CAREER_MODAL_FILE_SIZE')}}></div>
                  </div>
                  <div className="i-agree-block">
                      <Checkbox
                          checked={this.state.agree}
                          onChange={() => this.setState({
                            agree: !this.state.agree
                          })}
                          className="checkbox-agree"
                      >
                          <span dangerouslySetInnerHTML={{__html: this.l10n('MODAL_AGREE_TEXT')}}></span>
                      </Checkbox>
                  </div>
                </div>
                {this.state.error ? <div className="request-message request-error" dangerouslySetInnerHTML={{__html: this.l10n('CAREER_MODAL_REQUEST_ERROR')}}></div> : ''}
                {this.state.success ? <div className="request-message request-success" dangerouslySetInnerHTML={{__html: this.l10n('CAREER_MODAL_REQUEST_SUCCESS')}}></div> : ''}
                <button className="form-send-btn" disabled={!model.isValid || !this.state.agree} onClick={this.sendForm}>
                  {this.l10n('VACANCY_FORM_BTN')}
                </button>
              </div>
            </div>
        </div>
    )
}
